import React from 'react';

const NucleoContext = React.createContext();

export default NucleoContext;